//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'AnionGap_Urine',
  data() {
    return {
      defaultJson:{
        "urine Na": "尿 Na",
        "urine K": "尿 K",
        "urine Cl": "尿 Cl",
      },
      form:{
        Na:'',
        K:'',
        Cl:''
      },
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        let result = form.Na + form.K - form.Cl

        self.hasScore = true
        return String((result).toFixed(0))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Renal/AnionGap.vue